import axios from "axios";
import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// Checks if user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 && response.status <= 299) {
        // Store user_id in sessionStorage
        sessionStorage.setItem("userId", response.data.data.user_id);
        console.log("User ID stored in sessionStorage:", response.data.data.user_id);
        return response.data;
      }
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! The page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! Something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1] || "An unknown error occurred";
            break;
        }
      }
      throw message;
    });
};


// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data);

// Forgot Password Method (Updated)
const postFakeForgetPwd = username => {
  return axios
    .get(`${url.POST_FAKE_PASSWORD_FORGET}/${username}`)
    .then(response => {
      if (response.status >= 200 && response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! The page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! Something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1] || "An unknown error occurred";
            break;
        }
      }
      throw message;
    });
};


// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);
const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method (JWT)
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 && response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! The page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! Something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1] || "An unknown error occurred";
            break;
        }
      }
      throw message;
    });
};

// Login Method (JWT)
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// Forgot Password Method (JWT)
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// Social Login
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile
};
